/** A section tag is meaningful only among this viewer's same-term twins. */
export interface CourseSectionIdentity {
  course_id: string;
  code: string;
  title: string;
  crn: string | null;
  term: { id?: string; name: string } | null;
  lead_name?: string | null;
  instructor_name?: string | null;
}

export function courseSectionTag(courseId: string, courses: readonly CourseSectionIdentity[]): string | null {
  const course = courses.find(row => row.course_id === courseId);
  if (!course?.term) return null;
  const term = course.term.id ?? course.term.name;
  const twins = courses.filter(row => row.term && (row.term.id ?? row.term.name) === term && row.code === course.code && row.title === course.title);
  if (twins.length < 2) return null;
  const names = twins.map(row => (row.lead_name ?? row.instructor_name)?.trim() || null);
  if (names.every(Boolean) && new Set(names).size === twins.length) {
    return names[twins.indexOf(course)];
  }
  return course.crn ? `CRN ${course.crn}` : null;
}
